__turbopack_context__.v({
  "card": "styles-module__LLzNcG__card",
  "productImage": "styles-module__LLzNcG__productImage",
  "productLink": "styles-module__LLzNcG__productLink",
  "products": "styles-module__LLzNcG__products",
  "productsTablet3": "styles-module__LLzNcG__productsTablet3",
});
